// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__kNXYU","title":"Header_title__3L08p","rightSection":"Header_rightSection__198uu"};